import { useMutation, useQueryClient } from '@tanstack/react-query';
import { api } from 'src/common/utils/api';

type GenerateMeetingAgendaPayload = {
  templateId?: string;
};

export function useGenerateMeetingAgenda() {
  const queryClient = useQueryClient();

  const {
    mutateAsync,
    error,
    isPending: isLoading,
    reset,
  } = useMutation<unknown, Error, { clientId: string; values: GenerateMeetingAgendaPayload }>({
    mutationFn: ({
      clientId,
      values,
    }: {
      clientId: string;
      values: GenerateMeetingAgendaPayload;
    }) => api.post(`clients/${clientId}/meeting-agendas`, values),
    onSuccess: (_data, { clientId }) => {
      queryClient.invalidateQueries({ queryKey: ['clients', clientId, 'meeting-agendas'] });
    },
  });

  const generateMeetingAgenda = async (clientId: string, values: GenerateMeetingAgendaPayload) => {
    return mutateAsync({ clientId, values });
  };

  return {
    generateMeetingAgenda,
    error,
    isLoading,
    reset,
  };
}
